import { useMemo } from "react";
import { useAuth } from "../context/authContext";

// Derived straight from the auth state (not set in an effect) so a page that
// loads the session server-side renders unlocked content on the first paint.
//
// Prefers the session's `subscribed` flag: it is the same User#subscribed? the
// API paywall uses, so the UI locks exactly what the API withholds.
export const useValidSubscription = () => {
  const {
    state: { user, subscription },
  } = useAuth();

  return useMemo(() => {
    if (!user) return false;
    if (typeof user.subscribed === "boolean") return user.subscribed;

    return (
      user.subscription_expired === false &&
      !!(user.secondary_user || user.is_on_free_trial || subscription !== null)
    );
  }, [user, subscription]);
};
